import { render, staticRenderFns } from "./payRecordsDetails.vue?vue&type=template&id=69c530c2&scoped=true&"
import script from "./payRecordsDetails.vue?vue&type=script&lang=js&"
export * from "./payRecordsDetails.vue?vue&type=script&lang=js&"
import style0 from "./payRecordsDetails.vue?vue&type=style&index=0&id=69c530c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c530c2",
  null
  
)

export default component.exports